<template>
  <div :class="['layout', { 'has-hero': temHero }]">
    <!-- Cabeçalho global -->
    <HeaderView />

    <!-- Conteúdo dinâmico -->
    <main>
      <slot />
    </main>

<!-- Rodapé global -->
<FooterView v-if="!route.meta.hideFooter" />

<PopupWhatsApp/>

<!-- Toast global -->
<transition name="fade">
  <AlertaToast
    v-if="toast.state.visible"
    :type="toast.state.type"
    :message="toast.state.message"
  />
</transition>

  </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import HeaderView from "@/components/HeaderComponent.vue";
import FooterView from "@/components/FooterComponent.vue";
import AlertaToast from "@/components/AlertaToast.vue";
import { provideToast } from "@/composables/useToast";
import PopupWhatsApp from "@/components/global/PopupWhatsApp.vue";

const toast = provideToast();
const route = useRoute();
const temHero = ref(false);

/* ----------------------------------------------------------
   🔍 Função de detecção de hero
   ---------------------------------------------------------- */
const detectarHero = async () => {
  await nextTick();
  // procura por um hero padrão (classe usada em HeroResponsivo, HeroCarousel, etc)
  const existeHero = document.querySelector(
    ".hero-responsivo, .hero-carousel, .hero-principal, .hero-section"
  );
  temHero.value = !!existeHero;
};

/* ----------------------------------------------------------
   🎯 Monitorar troca de rotas
   ---------------------------------------------------------- */
watch(
  () => route.fullPath,
  () => detectarHero()
);

onMounted(() => {
  detectarHero();
});
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  transition: all 0.3s ease;
}

main {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: padding-top 0.3s ease;
}

/* Aplica padding APENAS nas páginas sem hero */
.layout:not(.has-hero) main {
  padding-top: var(--header-altura);
}

/* Remove totalmente o padding nas páginas com hero */
.layout.has-hero main {
  padding-top: 0 !important;
}

/* Animação de fade do toast */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
